import React from 'react';

import { cn } from '@/utils/classname';

import type { SentenceBodyPart } from './scanScheduleSentence';

/**
 * Renders the structured §E sentence segments with chariot-token styling
 * (FIDELITY A6): frequency phrase = brand-primary bold; day list / "first
 * {weekday}" = bold; time window = mono. Single renderer reused by the card
 * (A5) and the wizard summary band (C4) — DRY.
 */
export const SentenceText: React.FC<{
  parts: SentenceBodyPart[];
  className?: string;
  'data-testid'?: string;
}> = ({ parts, className, 'data-testid': testId }) => (
  <span className={className} data-testid={testId}>
    {parts.map((part, i) => {
      if ('accent' in part) {
        return (
          <span key={i} className="text-chariot-brand-primary font-bold">
            {part.text}
          </span>
        );
      }
      if ('bold' in part) {
        return (
          <span key={i} className="font-bold">
            {part.text}
          </span>
        );
      }
      if ('mono' in part) {
        return (
          <span key={i} className={cn('font-mono')}>
            {part.text}
          </span>
        );
      }
      return <React.Fragment key={i}>{part.text}</React.Fragment>;
    })}
  </span>
);
